<template>
  <div class="s-new-theme"
    style="width:800px;height:800px;position:absolute;left:50%;top:50%;margin-left:-400px;margin-top:-400px;">
    <div class="login-content-box">
      <div class="login-content-box-1">
        <div class="login-content-box-1-top">
          <!-- <p class="p1" @click="$router.push('blogin')">验证码登录</p> -->
          <p class="p2 s-red-color">Exhibitor Login</p>
          <p class="p2 s-red-color" @click="linkEn" style="cursor: pointer;" >
           <span style="border-radius: 50%;
    border: 1px solid rgb(209, 49, 25);
    padding: 5px">中</span>
          </p>
          <!-- <p class="p2 p3" @click="linkHost">主办登录</p> -->
        </div>
        <div class="login-content-box-1-bottom">
          <Form class="F" ref="formInline" :model="formInline" :rules="ruleInline"
            @keyup.enter.native="handleSubmit('formInline')">
            <FormItem class="F-1" prop="user">
              <Input class="I" type="text" v-model="formInline.user" placeholder="Username" />
            </FormItem>
            <FormItem class="F-1" prop="password">
              <Input class="I" type="password" v-model="formInline.password" placeholder="Password" />
            </FormItem>
            <FormItem class="F-1" prop="captcha">
              <Input class="I" v-model="formInline.captcha" placeholder="Captcha" />
              <img class="code" :src="code.image" alt="验证码" v-if="code && code.image" @click="getCode" />
            </FormItem>
            <div class="F-2">
              <Checkbox class="save-btn" v-model="remember">&nbsp;&nbsp;&nbsp;Remember me</Checkbox>
              <p class="F-2-text" style="font-size:14px;width:105px;color:#515a6e;" @click="resetShow1 = true;">Forgot
                password</p>
            </div>
            <Button type="primary" @click="handleSubmit('formInline')" size="large" :loading="loading"
              class="s-btn-red">Login</Button>
            <!-- <Button class="wx-btn" @click="$router.push('clogin')" size="large">
            <span class="wx-icon">
              <img src="../img/weixin.png" alt="微信" />
            </span>微信扫码登录
          </Button>-->
          </Form>
        </div>
      </div>
    </div>
    <!-- <div class="login-content-text">
      <h3>Exhibitor Center</h3>
      <p>Dear exhibitors, welcome to participating in the CMEF exhibition.</p>
      <p>Please log in to enter the Exhibitor Center to perfect your company and product information. </p>
      <p>Every text you fill in will play an important role in your business promotion online and offline.</p>
    </div> -->

    <iModal title="Retrieve password" @on-cancel="cancel" v-model="resetShow1">
      <Form ref="formReset1" :model="formReset1" :rules="ruleReset1" inline :label-width="140">
        <FormItem label="Mobile phone：" prop="phone">
          <Input type="text" style="width:300px;" v-model="formReset1.phone"
            placeholder="Please enter your mobile phone" />
        </FormItem>
        <FormItem label="Captcha：" prop="captcha">
          <Input type="text" style="width:180px;margin-right:20px;" v-model="formReset1.captcha"
            placeholder="Please enter captcha" />
          <Button v-if="showCode" @click="getCaptcha('formReset1')" style="width: 100px;padding:0;">Get Captcha</Button>
          <Button v-else disabled style="width: 100px;padding:0;">{{ count }}s</Button>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" class="s-btn-red" @click="cancel">cancel</Button>
        <Button type="primary" class="s-btn-red" @click="reset('formReset1')">confirm</Button>
      </div>
    </iModal>

    <!-- 修改密码modal -->
    <iModal title="Change the password" @on-cancel="cancel2" v-model="resetShow2" class-name="newPas" :closable="false">
      <Form ref="formReset2" :model="formReset2" :rules="ruleReset2" inline :label-width="140">
        <FormItem label="New Password：" prop="newPhone">
          <Input type="text" style="width:300px;" v-model="formReset2.newPhone"
            placeholder="Please enter new password" />
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" class="s-btn-red" @click="cancel2">cancel</Button>
        <Button type="primary" class="s-btn-red" @click="reset2('formReset2')">confirm</Button>
      </div>
    </iModal>
  </div>
</template>

<script>
import CryptoJS from "crypto-js";
import { mapActions, mapMutations, mapGetters } from "vuex";

export default {
  data () {
    return {
      resetShow1: false,
      resetShow2: false,
      showCode: true, // 是否可以获取验证码
      count: "", // 获取验证码的秒数
      formReset1: {
        phone: "",
        captcha: ""
      },
      ruleReset1: {
        phone: [{ required: true, message: "Please enter your mobile phone", trigger: "blur" }],
        captcha: [{ required: true, message: "Please enter captcha", trigger: "blur" }],
      },
      formReset2: {
        newPhone: "",
      },
      ruleReset2: {
        newPhone: [{ required: true, message: "The password cannot be empty", trigger: "blur" },
        {
          type: "string",
          min: 4,
          message: "The password cannot be less than 4 digits",
          trigger: "blur"
        },
        {
          type: "string",
          max: 50,
          message: "The password cannot be greater than 50 digits",
          trigger: "blur"
        }
        ],
      },
      passedPhone: "",
      passedCaptcha: "",

      formInline: {
        user: "",
        password: "",
        captcha: ""
      },
      ruleInline: {
        user: [{ required: true, message: "User name is required", trigger: "blur" }],
        password: [
          { required: true, message: "Wrong username or password", trigger: "blur" },
          {
            type: "string",
            min: 4,
            message: "The password cannot be less than 4 digits",
            trigger: "blur"
          },
          {
            type: "string",
            max: 50,
            message: "The password cannot be greater than 50 digits",
            trigger: "blur"
          }
        ],
        captcha: [{ required: true, message: "Captcha is required", trigger: "blur" }]
      },
      code: null, // 二维码信息
      remember: false, // 记住我
      loading: false,
      exhibitionId: "",
    };
  },
  async created () {
    await this.getAllConfiSettle('exhibition');
    this.getCode();
    this.init();
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany",
      ExhibitionIdArr: 'getExhibitionIdArr',
    }),
    // exhibitionId() {
    //   return config.ExhibitionId;
    // },
  },
  methods: {
    ...mapMutations({
      setRole: "setRole",
      setUser: "setUser",
      setToken: "setToken",
      setTokenTime: "setTokenTime",
      setLogin: "setLogin",
      setCompany: "loginModule/setCompany",
      setExhibition: "loginModule/setExhibition",
      setJoinInfo: "loginModule/setJoinInfo"
    }),
    ...mapActions({
      getAllConfiSettle: "getAllConfiSettle",
      getUser: "loginModule/getUser",
      getToken: "loginModule/getToken",
      getCompany: "loginModule/getCompany",
      getImgCode: "loginModule/getImgCode",
      validateImgCode: "loginModule/validateImgCode",
      getExhibitionById: "exhibitionModule/getExhibitionById",
      getDefaultJoinExhibition: "companyModule/getDefaultJoinExhibition",
      getJoinInfo: "loginModule/getJoinInfo",
      getExIdByUserId: "loginModule/getExIdByUserId",
      getVerCode: "companyModule/getVerCode",
      asyncVerCode: "companyModule/asyncVerCode",
      editVerCode: "companyModule/editVerCode"
    }),
    init () {
      let name = this.$cookies.get('name');
      let pwd = this.$cookies.get('pwd');
      if (name && pwd) {
        let password = CryptoJS.AES.decrypt(pwd, "GY-key").toString(CryptoJS.enc.Utf8);
        // console.log("解密结果：" + password);
        this.remember = true;
        this.formInline.user = name;
        this.formInline.password = password;
      }
    },
    cancel () {
      this.resetShow1 = false;
      this.formReset1.phone = "",
        this.$refs.formReset1.resetFields();
    },
    cancel2 () {
      this.resetShow2 = false;
      this.formReset2.newPhone = "",
        this.$refs.formReset2.resetFields();
    },
    async getCaptcha (name) {
      let valid = await this.validField();
      if (valid) return;
      this.downTime(name);
    },
    async downTime () {
      let info = await this.getVerCode({
        Phone: this.formReset1.phone
      });
      if (!info || !info.successed) {
        if (info.errors[0].description) {
          this.$Message.warning(info.errors[0].description);
        } else {
          this.$Message.warning("fail,please try again");
        }
        return;
      }
      this.$Message.success("send successfully");
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.showCode = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.showCode = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    async reset (name) {
      let valid = await this.validForm(name);
      if (!valid) return;
      let req = {
        Phone: this.formReset1.phone,
        token: this.formReset1.captcha
      }
      let bool = await this.asyncVerCode(req);
      if (!bool || !bool.successed) {
        if (bool.errors[0].description) {
          this.$Message.warning(bool.errors[0].description);
        } else {
          this.$Message.warning("fail,please try again");
        }
        return;
      }
      this.passedPhone = this.formReset1.phone;
      this.passedCaptcha = this.formReset1.captcha;
      this.cancel();
      this.resetShow2 = true;
    },
    async reset2 (name) {
      let valid = await this.validForm(name);
      if (!valid) return;
      let req = {
        Phone: this.passedPhone,
        Token: this.passedCaptcha,
        NewPassword: this.formReset2.newPhone,
      }
      let bool = await this.editVerCode(req);
      if (bool && bool.successed) {
        this.$Message.success("success");
        this.cancel2();
      } else {
        if (bool.errors[0].description) {
          this.$Message.warning(bool.errors[0].description);
        } else {
          this.$Message.warning("fail,please try again");
        }
      }
    },
    async handleSubmit (name) {
      let form = this.formInline;
      let valid = await this.validForm(name);
      if (!valid) return;
      let codeValid = await this.validCode();
      if (!codeValid) return;
      let formData = {
        grant_type: "password",
        client_id: "cloud.exhibition",
        client_secret: "secret",
        username: form.user,
        password: form.password,
        scope: "synair offline_access"
      };
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 5000);
      let tokenData = await this.getToken(formData);
      if (tokenData) {
        this.setRole(2);
        this.setToken(tokenData.access_token);
        this.setTokenTime(tokenData.expires_in * 1000 + new Date().getTime());
        let user = await this.getUser();
        let company = await this.getCompany(user.id);
        if (!company) {
          // this.$router.push("/exhibition/register-company");
          this.$Message.warning("未绑定公司信息！");
          return;
        } else {
          this.setCompany(company);
          // console.log("公司信息：", company);
          let idInfo = await this.getExIdByUserId(user.id);
          if (idInfo && idInfo.ExhibitionId) {
            if (this.ExhibitionIdArr.indexOf(idInfo.ExhibitionId) !== -1) {
              this.exhibitionId = idInfo.ExhibitionId;
              // let exhibition = await this.getDefaultJoinExhibition(company.id);
              let exData = await this.getExhibitionById(this.exhibitionId);
              this.setExhibition(exData);
              // console.log("展会信息：", exData);
              this.setLogin(true);
              let joinInfo = await this.getJoinInfo({
                ExhibitionId: this.exhibitionId
              });
              if (joinInfo) {
                this.setJoinInfo(joinInfo.info);
                // 保存密码
                if (this.remember) {
                  let pwd = CryptoJS.AES.encrypt(String(form.password), "GY-key").toString();
                  // console.log("加密结果"+ pwd);
                  this.$cookies.set("name", form.user, 60 * 60 * 24 * 7);
                  this.$cookies.set("pwd", pwd, 60 * 60 * 24 * 7);
                } else {
                  this.$cookies.remove("name");
                  this.$cookies.remove("pwd");
                }
                this.$Message.success("Login Successful");
                localStorage.setItem('password', form.password)
                this.$router.push("/exhibitionEn/index/home");
              } else {
                this.$Message.warning("未绑定展会信息！");
              }
            } else {
              this.$Message.warning("未绑定展会信息！");
            }
          } else {
            this.$Message.warning("未绑定展会信息！");
          }
        }
      }
      this.loading = false;
    },
    async getCode () {
      // 获取code
      this.code = await this.getImgCode();
    },
    validForm (name) {
      // 验证表单
      return new Promise((resolve, ) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    validField () {
      // 验证单个表单
      return new Promise((resolve, ) => {
        this.$refs.formReset1.validateField('phone', valid => {
          resolve(valid);
        });
      });
    },
    async validCode () {
      // 验证code
      if (!this.code || !this.formInline.captcha) return false;
      let valid = await this.validateImgCode({
        Key: this.code.key,
        Code: this.formInline.captcha
      });
      if (!valid) {
        this.$Message.error("验证未通过!");
        return false;
      }
      if (valid.errors && valid.errors[0]) {
        if (valid.errors[0].code === 400110) {
          this.$Message.error("Please re-enter the captcha");
        } else {
          this.$Message.error(valid.errors[0].description);
        }
        this.getCode();
        return false;
      }
      return true;
    },
    linkHost () {
      location.href = "/#/host/login/alogin";
      },
     linkEn () {
        location.href = '/exhibition/login/alogin'
      },
  }
};
</script>

<style lang="scss" scoped>
.login-content-box {
  width: 360px;
  height: 420px;
  background-color: #fff;
  border-radius: 2px;
  // background: rgba(0, 0, 0, 0.3);
  position: absolute;
  right: -25%;
  bottom: 35%;
  display: flex;
  align-items: center;
  justify-content: center;

  &-1 {
    width: 360px;
    height: 420px;
    background-color: #fff;
    box-shadow: 0px 0px 10px 0px rgba(139, 140, 140, 0.3);
    border-radius: 2px;
    position: relative;

    &-top {
      width: 370px;
      height: 40px;
      position: absolute;
      top: 20px;
      left: 30px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .p1 {
        width: 91px;
        height: 17px;
        font-size: 18px;
        line-height: 16px;
        color: #808080;
        cursor: pointer;
        font-weight: bold;
      }

      .p2 {
        width: 100%;
        text-align: center;
        height: 19px;
        font-size: 18px;
        line-height: 16px;
        color: #d13119;
        cursor: pointer;
        font-weight: bold;
      }

      .p3 {
        color: #808080;

        &:hover {
          color: #d13119;
        }
      }
    }

    &-bottom {
      width: 300px;
      height: 350px;
      position: absolute;
      top: 49px;
      left: 29px;
    }
  }

  .wx-icon {
    width: 22px;
    height: 22px;
    padding: 3px 5px;
    background-color: #3eb135;
    border-radius: 50%;
    display: inline-block;
    margin-right: 8px;

    img {
      width: 13px;
      height: 11px;
    }
  }
}

.F {
  display: flex;
  flex-direction: column;
  width: 300px;
  height: 350px;
  position: relative;

  &-1 {
    margin-top: 15px;
    margin-bottom: 0;

    .I {
      margin-top: 19px;
    }
  }

  .F-2 {
    width: 100%;
    height: 15px;
    line-height: 15px;
    display: flex;
    justify-content: space-between;
    margin: 24px 0;

    .F-2-text {
      width: 48px;
      height: 13px;
      font-size: 12px;
      color: #333;
      cursor: pointer;
    }
  }

  .wx-btn {
    margin-top: 20px;
  }

  .code {
    width: 70px;
    height: 26px;
    position: absolute;
    top: 22px;
    right: 8px;
    cursor: pointer;
  }
}

.login-content-text {
  position: absolute;
  left: -50%;
  bottom: 48%;
  color: #db2a4b;

  h3 {
    font-size: 50px;
    margin-bottom: 80px;
  }

  p {
    font-size: 20px;
    font-weight: bold;
  }
}

/deep/ .newPas {
  .ivu-modal-body {
    padding: 24px 0 0 16px;
  }
}
</style>